import { useState } from 'react'
import { Icon } from './Icon'
import { Vars } from './Vars'

export const CAR_ICON_LIST = [
  { id: 'sedan',        label: 'Седан'       },
  { id: 'jeep',         label: 'Джип'        },
  { id: 'pickup',       label: 'Пикап'       },
  { id: 'sport',        label: 'Спорткар'    },
  { id: 'hatchback',    label: 'Хэтчбек'     },
  { id: 'gazelle',      label: 'Газель'      },
  { id: 'van',          label: 'Фургон'      },
  { id: 'small_truck',  label: 'Малый груз.' },
  { id: 'truck',        label: 'Грузовик'    },
  { id: 'semi',         label: 'Фура'        },
]

const ICON_COLORS = [
  '#1a3a5c','#1b3a1c','#3e1f00','#1a1a2e','#2c1654',
  '#1a3320','#0d2744','#2a1a00','#0d1f36','#1a1a1a',
  '#7b1fa2','#00695c','#c62828','#4527a0','#f57f17',
]

export const isCarIcon     = (s) => typeof s === 'string' && s.startsWith('icon:')
export const parseIconValue = (s) => {
  if (!isCarIcon(s)) return null
  const p = s.replace('icon:', '').split(':')
  return { id: p[0], color: p[1] || '#1a3a5c' }
}
export const buildIconValue = (id, color) => `icon:${id}:${color}`

// ── SVG иконки ───────────────────────────────────────────────────────────────

function IconSedan({ s = 1 }) {
  return (
    <svg viewBox="0 0 80 60" width={80*s} height={60*s}>
      <ellipse cx="40" cy="54" rx="32" ry="4" fill="rgba(0,0,0,0.3)"/>
      <path d="M8 38 Q8 34 12 34 L68 34 Q72 34 72 38 L72 48 Q72 50 70 50 L10 50 Q8 50 8 48Z" fill="#2196f3"/>
      <path d="M14 34 L20 22 Q22 18 28 18 L52 18 Q58 18 60 22 L66 34Z" fill="#1976d2"/>
      <path d="M22 22 L26 34 L54 34 L58 22 Q56 19 52 19 L28 19 Q24 19 22 22Z" fill="#90caf9" opacity=".85"/>
      <line x1="40" y1="18" x2="40" y2="34" stroke="#1565c0" strokeWidth="1.5"/>
      <rect x="22" y="19" width="4" height="14" rx="1" fill="#bbdefb" opacity=".4"/>
      <rect x="54" y="19" width="4" height="14" rx="1" fill="#bbdefb" opacity=".4"/>
      <rect x="8" y="40" width="8" height="5" rx="1" fill="#fff9c4"/>
      <rect x="64" y="40" width="8" height="5" rx="1" fill="#ef9a9a"/>
      <rect x="10" y="35" width="3" height="3" rx="1" fill="#b0bec5"/>
      <rect x="67" y="35" width="3" height="3" rx="1" fill="#b0bec5"/>
      <circle cx="22" cy="50" r="7" fill="#212121"/>
      <circle cx="22" cy="50" r="4" fill="#455a64"/>
      <circle cx="22" cy="50" r="2" fill="#90a4ae"/>
      <circle cx="58" cy="50" r="7" fill="#212121"/>
      <circle cx="58" cy="50" r="4" fill="#455a64"/>
      <circle cx="58" cy="50" r="2" fill="#90a4ae"/>
    </svg>
  )
}

function IconJeep({ s = 1 }) {
  return (
    <svg viewBox="0 0 80 60" width={80*s} height={60*s}>
      <ellipse cx="40" cy="54" rx="33" ry="4" fill="rgba(0,0,0,0.3)"/>
      <path d="M6 36 Q6 32 10 32 L70 32 Q74 32 74 36 L74 50 Q74 52 72 52 L8 52 Q6 52 6 50Z" fill="#388e3c"/>
      <path d="M10 32 L10 20 Q10 16 14 16 L66 16 Q70 16 70 20 L70 32Z" fill="#2e7d32"/>
      <path d="M14 17 L14 31 L34 31 L34 17Z" fill="#81c784" opacity=".7"/>
      <path d="M46 17 L46 31 L66 31 L66 17Z" fill="#81c784" opacity=".7"/>
      <rect x="34" y="16" width="12" height="16" fill="#1b5e20"/>
      <rect x="6" y="16" width="52" height="2" fill="#263238"/>
      <rect x="6" y="38" width="10" height="6" rx="1" fill="#fff9c4"/>
      <rect x="64" y="38" width="10" height="6" rx="1" fill="#ef9a9a"/>
      <rect x="8" y="32" width="3" height="4" rx="1" fill="#b0bec5"/>
      <rect x="69" y="32" width="3" height="4" rx="1" fill="#b0bec5"/>
      <rect x="6" y="48" width="68" height="3" rx="1" fill="#1b5e20"/>
      <circle cx="20" cy="52" r="8" fill="#212121"/>
      <circle cx="20" cy="52" r="5" fill="#37474f"/>
      <circle cx="20" cy="52" r="2.5" fill="#90a4ae"/>
      <circle cx="60" cy="52" r="8" fill="#212121"/>
      <circle cx="60" cy="52" r="5" fill="#37474f"/>
      <circle cx="60" cy="52" r="2.5" fill="#90a4ae"/>
    </svg>
  )
}

function IconPickup({ s = 1 }) {
  return (
    <svg viewBox="0 0 80 60" width={80*s} height={60*s}>
      <ellipse cx="40" cy="54" rx="33" ry="4" fill="rgba(0,0,0,0.3)"/>
      <path d="M6 36 Q6 32 10 32 L74 32 Q74 32 74 36 L74 50 Q74 52 72 52 L8 52 Q6 52 6 50Z" fill="#e65100"/>
      <path d="M10 32 L14 20 Q16 16 20 16 L44 16 L44 32Z" fill="#bf360c"/>
      <path d="M16 18 L20 31 L40 31 L40 18Z" fill="#ff8a65" opacity=".7"/>
      <rect x="44" y="24" width="30" height="8" rx="1" fill="#8d2600" stroke="#6d1e00" strokeWidth="0.5"/>
      <rect x="46" y="26" width="26" height="4" rx="1" fill="#5d1600" opacity=".5"/>
      <rect x="6" y="38" width="8" height="5" rx="1" fill="#fff9c4"/>
      <rect x="66" y="38" width="8" height="5" rx="1" fill="#ef9a9a"/>
      <rect x="8" y="33" width="3" height="3" rx="1" fill="#b0bec5"/>
      <circle cx="19" cy="52" r="8" fill="#212121"/>
      <circle cx="19" cy="52" r="5" fill="#37474f"/>
      <circle cx="19" cy="52" r="2.5" fill="#90a4ae"/>
      <circle cx="61" cy="52" r="8" fill="#212121"/>
      <circle cx="61" cy="52" r="5" fill="#37474f"/>
      <circle cx="61" cy="52" r="2.5" fill="#90a4ae"/>
    </svg>
  )
}

function IconSport({ s = 1 }) {
  return (
    <svg viewBox="0 0 80 52" width={80*s} height={52*s}>
      <ellipse cx="40" cy="47" rx="33" ry="3.5" fill="rgba(0,0,0,0.3)"/>
      <path d="M6 30 Q5 26 9 26 L71 26 Q75 26 75 30 L75 42 Q75 44 73 44 L7 44 Q5 44 6 42Z" fill="#0288d1"/>
      <path d="M9 26 L15 14 Q17 10 23 10 L57 10 Q63 10 65 14 L71 26Z" fill="#01579b"/>
      <path d="M18 11 L23 25 L57 25 L62 11 Q60 11 57 11 L23 11Z" fill="#80d8ff" opacity=".55"/>
      <line x1="40" y1="10" x2="40" y2="26" stroke="#004c8c" strokeWidth="1.5"/>
      <rect x="6" y="31" width="9" height="5" rx="1" fill="#fff9c4"/>
      <rect x="65" y="31" width="9" height="5" rx="1" fill="#ef9a9a"/>
      <rect x="9" y="26" width="3" height="4" rx="1" fill="#b0bec5"/>
      <rect x="68" y="26" width="3" height="4" rx="1" fill="#b0bec5"/>
      <circle cx="20" cy="44" r="7" fill="#212121"/>
      <circle cx="20" cy="44" r="4" fill="#37474f"/>
      <circle cx="20" cy="44" r="2" fill="#90a4ae"/>
      <circle cx="60" cy="44" r="7" fill="#212121"/>
      <circle cx="60" cy="44" r="4" fill="#37474f"/>
      <circle cx="60" cy="44" r="2" fill="#90a4ae"/>
    </svg>
  )
}

function IconHatchback({ s = 1 }) {
  return (
    <svg viewBox="0 0 80 60" width={80*s} height={60*s}>
      <ellipse cx="40" cy="54" rx="33" ry="4" fill="rgba(0,0,0,0.3)"/>
      <path d="M6 36 Q6 32 10 32 L70 32 Q74 32 74 36 L74 50 Q74 52 72 52 L8 52 Q6 52 6 50Z" fill="#5c6bc0"/>
      <path d="M14 32 L20 20 Q22 16 28 16 L52 16 Q58 16 60 20 L66 32Z" fill="#3949ab"/>
      <path d="M22 17 L26 31 L54 31 L58 17 Q56 17 52 17 L28 17Z" fill="#9fa8da" opacity=".75"/>
      <line x1="40" y1="16" x2="40" y2="32" stroke="#303f9f" strokeWidth="1.5"/>
      <rect x="6" y="38" width="8" height="5" rx="1" fill="#fff9c4"/>
      <rect x="66" y="38" width="8" height="5" rx="1" fill="#ef9a9a"/>
      <rect x="8" y="33" width="3" height="3" rx="1" fill="#b0bec5"/>
      <rect x="69" y="33" width="3" height="3" rx="1" fill="#b0bec5"/>
      <rect x="6" y="48" width="68" height="3" rx="1.5" fill="#283593"/>
      <circle cx="20" cy="52" r="7" fill="#212121"/>
      <circle cx="20" cy="52" r="4" fill="#455a64"/>
      <circle cx="20" cy="52" r="2" fill="#90a4ae"/>
      <circle cx="60" cy="52" r="7" fill="#212121"/>
      <circle cx="60" cy="52" r="4" fill="#455a64"/>
      <circle cx="60" cy="52" r="2" fill="#90a4ae"/>
    </svg>
  )
}

function IconGazelle({ s = 1 }) {
  return (
    <svg viewBox="0 0 90 56" width={90*s} height={56*s}>
      <ellipse cx="45" cy="50" rx="36" ry="4" fill="rgba(0,0,0,0.3)"/>
      <rect x="4" y="26" width="22" height="20" rx="3" fill="#2e7d32"/>
      <rect x="6" y="14" width="18" height="14" rx="2" fill="#388e3c"/>
      <rect x="8" y="16" width="14" height="10" rx="1" fill="#a5d6a7" opacity=".75"/>
      <rect x="26" y="18" width="60" height="28" rx="2" fill="#1b5e20"/>
      <rect x="28" y="20" width="56" height="24" rx="1" fill="#2e7d32"/>
      <line x1="24" y1="20" x2="26" y2="20" stroke="#1b5e20" strokeWidth="2"/>
      <rect x="30" y="22" width="24" height="18" rx="1" fill="#424242" opacity=".3"/>
      <rect x="4" y="32" width="8" height="5" rx="1" fill="#fff9c4"/>
      <rect x="82" y="32" width="4" height="5" rx="1" fill="#ef9a9a"/>
      <circle cx="17" cy="48" r="8" fill="#212121"/>
      <circle cx="17" cy="48" r="5" fill="#37474f"/>
      <circle cx="17" cy="48" r="2.5" fill="#90a4ae"/>
      <circle cx="72" cy="48" r="8" fill="#212121"/>
      <circle cx="72" cy="48" r="5" fill="#37474f"/>
      <circle cx="72" cy="48" r="2.5" fill="#90a4ae"/>
    </svg>
  )
}

function IconVan({ s = 1 }) {
  return (
    <svg viewBox="0 0 90 56" width={90*s} height={56*s}>
      <ellipse cx="45" cy="51" rx="36" ry="3.5" fill="rgba(0,0,0,0.3)"/>
      <rect x="4" y="24" width="24" height="24" rx="3" fill="#1976d2"/>
      <rect x="6" y="12" width="20" height="14" rx="2" fill="#1e88e5"/>
      <rect x="8" y="14" width="16" height="10" rx="1" fill="#90caf9" opacity=".8"/>
      <rect x="28" y="16" width="58" height="32" rx="2" fill="#0d47a1"/>
      <rect x="30" y="18" width="54" height="28" rx="1" fill="#1565c0"/>
      <rect x="44" y="20" width="2" height="26" rx="1" fill="#0d47a1" opacity=".5"/>
      <rect x="4" y="30" width="8" height="5" rx="1" fill="#fff9c4"/>
      <rect x="84" y="30" width="4" height="5" rx="1" fill="#ef9a9a"/>
      <circle cx="16" cy="49" r="8" fill="#212121"/>
      <circle cx="16" cy="49" r="5" fill="#37474f"/>
      <circle cx="16" cy="49" r="2.5" fill="#90a4ae"/>
      <circle cx="73" cy="49" r="8" fill="#212121"/>
      <circle cx="73" cy="49" r="5" fill="#37474f"/>
      <circle cx="73" cy="49" r="2.5" fill="#90a4ae"/>
    </svg>
  )
}

function IconSmallTruck({ s = 1 }) {
  return (
    <svg viewBox="0 0 90 56" width={90*s} height={56*s}>
      <ellipse cx="45" cy="51" rx="36" ry="3.5" fill="rgba(0,0,0,0.3)"/>
      <rect x="4" y="28" width="20" height="20" rx="3" fill="#e65100"/>
      <rect x="6" y="16" width="16" height="14" rx="2" fill="#f4511e"/>
      <rect x="7" y="18" width="14" height="10" rx="1" fill="#ffccbc" opacity=".8"/>
      <rect x="24" y="22" width="62" height="26" rx="2" fill="#bf360c"/>
      <rect x="26" y="24" width="58" height="22" rx="1" fill="#d84315"/>
      <rect x="40" y="26" width="2" height="20" rx="1" fill="#bf360c" opacity=".5"/>
      <rect x="4" y="34" width="8" height="5" rx="1" fill="#fff9c4"/>
      <rect x="84" y="34" width="4" height="5" rx="1" fill="#ef9a9a"/>
      <circle cx="14" cy="49" r="8" fill="#212121"/>
      <circle cx="14" cy="49" r="5" fill="#37474f"/>
      <circle cx="14" cy="49" r="2.5" fill="#90a4ae"/>
      <circle cx="75" cy="49" r="8" fill="#212121"/>
      <circle cx="75" cy="49" r="5" fill="#37474f"/>
      <circle cx="75" cy="49" r="2.5" fill="#90a4ae"/>
    </svg>
  )
}

function IconTruck({ s = 1 }) {
  return (
    <svg viewBox="0 0 96 56" width={96*s} height={56*s}>
      <ellipse cx="48" cy="51" rx="40" ry="3.5" fill="rgba(0,0,0,0.3)"/>
      <rect x="2" y="28" width="22" height="20" rx="3" fill="#1565c0"/>
      <rect x="4" y="14" width="18" height="16" rx="2" fill="#1976d2"/>
      <rect x="5" y="16" width="16" height="12" rx="1" fill="#90caf9" opacity=".8"/>
      <rect x="24" y="20" width="68" height="28" rx="2" fill="#0d47a1"/>
      <rect x="26" y="22" width="64" height="24" rx="1" fill="#1565c0"/>
      <rect x="44" y="24" width="2" height="22" rx="1" fill="#0d47a1" opacity=".5"/>
      <rect x="66" y="24" width="2" height="22" rx="1" fill="#0d47a1" opacity=".5"/>
      <rect x="2" y="36" width="10" height="5" rx="1" fill="#fff9c4"/>
      <rect x="88" y="36" width="4" height="5" rx="1" fill="#ef9a9a"/>
      <rect x="20" y="10" width="3" height="8" rx="1" fill="#546e7a"/>
      <circle cx="14" cy="49" r="8" fill="#212121"/>
      <circle cx="14" cy="49" r="5" fill="#37474f"/>
      <circle cx="14" cy="49" r="2.5" fill="#90a4ae"/>
      <circle cx="70" cy="49" r="8" fill="#212121"/>
      <circle cx="70" cy="49" r="5" fill="#37474f"/>
      <circle cx="70" cy="49" r="2.5" fill="#90a4ae"/>
      <circle cx="82" cy="49" r="8" fill="#212121"/>
      <circle cx="82" cy="49" r="5" fill="#37474f"/>
      <circle cx="82" cy="49" r="2.5" fill="#90a4ae"/>
    </svg>
  )
}

function IconSemi({ s = 1 }) {
  return (
    <svg viewBox="0 0 110 56" width={110*s} height={56*s}>
      <ellipse cx="55" cy="51" rx="48" ry="3.5" fill="rgba(0,0,0,0.3)"/>
      <rect x="2" y="26" width="20" height="22" rx="3" fill="#37474f"/>
      <rect x="4" y="12" width="16" height="16" rx="2" fill="#455a64"/>
      <rect x="5" y="14" width="14" height="12" rx="1" fill="#90a4ae" opacity=".8"/>
      <rect x="2" y="40" width="4" height="4" rx="1" fill="#fff9c4"/>
      <rect x="22" y="30" width="84" height="18" rx="2" fill="#263238"/>
      <rect x="24" y="32" width="80" height="14" rx="1" fill="#37474f"/>
      <rect x="48" y="32" width="2" height="14" rx="1" fill="#263238" opacity=".5"/>
      <rect x="74" y="32" width="2" height="14" rx="1" fill="#263238" opacity=".5"/>
      <rect x="2" y="12" width="4" height="8" rx="1" fill="#546e7a"/>
      <rect x="104" y="38" width="4" height="6" rx="1" fill="#ef9a9a"/>
      <circle cx="12" cy="49" r="8" fill="#212121"/>
      <circle cx="12" cy="49" r="5" fill="#37474f"/>
      <circle cx="12" cy="49" r="2.5" fill="#78909c"/>
      <circle cx="75" cy="49" r="8" fill="#212121"/>
      <circle cx="75" cy="49" r="5" fill="#37474f"/>
      <circle cx="75" cy="49" r="2.5" fill="#78909c"/>
      <circle cx="88" cy="49" r="8" fill="#212121"/>
      <circle cx="88" cy="49" r="5" fill="#37474f"/>
      <circle cx="88" cy="49" r="2.5" fill="#78909c"/>
      <circle cx="101" cy="49" r="6" fill="#212121"/>
      <circle cx="101" cy="49" r="3.5" fill="#37474f"/>
      <circle cx="101" cy="49" r="1.5" fill="#78909c"/>
    </svg>
  )
}

const ICON_COMPONENTS = {
  sedan:       IconSedan,
  jeep:        IconJeep,
  pickup:      IconPickup,
  sport:       IconSport,
  hatchback:   IconHatchback,
  gazelle:     IconGazelle,
  van:         IconVan,
  small_truck: IconSmallTruck,
  truck:       IconTruck,
  semi:        IconSemi,
}

function CarIconRender({ id, scale = 1 }) {
  const Comp = ICON_COMPONENTS[id]
  // Неизвестный тип — нейтральная иконка, а не эмодзи.
  if (!Comp) return <Icon name="car" size={32 * scale} />
  return <Comp s={scale} />
}

// ── Публичные компоненты ──────────────────────────────────────────────────────
//
// Геометрия и раскладка живут в base.css. Инлайн остаются только величины,
// которые вычисляются во время выполнения: выбранный пользователем цвет
// и запрошенный размер. Они передаются как CSS-переменные, а не как готовые
// свойства — так стилевые решения остаются в таблице стилей.

export function CarIconBadge({ src, size = 64, className = '' }) {
  const p = parseIconValue(src)
  if (!p) return null

  return (
    <Vars
      className={`car-badge ${className}`}
      vars={{ '--car-badge-size': `${size}px`, '--car-badge-bg': p.color }}
    >
      <CarIconRender id={p.id} scale={(size / 80) * 0.9} />
    </Vars>
  )
}

export function CarIconBanner({ src, brand, model }) {
  const p = parseIconValue(src)
  if (!p) return null

  return (
    <Vars className="car-banner" vars={{ '--car-banner-bg': p.color }}>
      <CarIconRender id={p.id} scale={1.8} />
      {(brand || model) && (
        <p className="car-banner__caption">
          {brand} {model}
        </p>
      )}
    </Vars>
  )
}

export function IconPickerModal({ current, onSelect, onClose }) {
  const p = parseIconValue(current)
  const [selId, setSelId] = useState(p?.id || 'sedan')
  const [selColor, setSelColor] = useState(p?.color || '#1a3a5c')

  return (
    <div
      className="sheet-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Выбор иконки автомобиля"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="sheet">
        <div className="sheet__header">
          <h3 className="sheet__title">Выбрать иконку</h3>
          <button type="button" className="btn-icon" onClick={onClose} aria-label="Закрыть">
            <Icon name="close" size={18} />
          </button>
        </div>
        <Vars className="icon-preview" vars={{ '--car-badge-bg': selColor }}>
          <CarIconRender id={selId} scale={1.8} />
        </Vars>

        <p className="section-title">Тип автомобиля</p>
        <div className="icon-grid" role="radiogroup" aria-label="Тип автомобиля">
          {CAR_ICON_LIST.map((icon) => {
            const active = selId === icon.id
            return (
              <Vars
                as="button"
                key={icon.id}
                type="button"
                role="radio"
                aria-checked={active}
                className={`icon-grid__item ${active ? 'is-active' : ''}`}
                vars={{ '--car-badge-bg': selColor }}
                onClick={() => setSelId(icon.id)}
              >
                <span className="icon-grid__thumb">
                  <CarIconRender id={icon.id} scale={0.55} />
                </span>
                <span className="icon-grid__label">{icon.label}</span>
              </Vars>
            )
          })}
        </div>

        <p className="section-title">Цвет фона</p>
        <div className="swatches" role="radiogroup" aria-label="Цвет фона">
          {ICON_COLORS.map((c) => (
            <Vars
              as="button"
              key={c}
              type="button"
              role="radio"
              aria-checked={selColor === c}
              aria-label={`Цвет ${c}`}
              className={`swatch ${selColor === c ? 'is-active' : ''}`}
              vars={{ '--swatch': c }}
              onClick={() => setSelColor(c)}
            />
          ))}
        </div>

        <button
          type="button"
          className="btn btn--primary btn--full"
          onClick={() => {
            onSelect(buildIconValue(selId, selColor))
            onClose()
          }}
        >
          <Icon name="check" size={16} />
          Применить иконку
        </button>
      </div>
    </div>
  )
}
